export const getImageSizeFromFile = (file: File): Promise<{ width: number; height: number }> =>
  new Promise((resolve, reject) => {
    // Get image size for selected file
    const url = window.URL || window.webkitURL;
    const objectUrl = url.createObjectURL(file);

    const img = new Image();
    img.onload = () => {
      const result = {
        width: img.width,
        height: img.height,
      };
      url.revokeObjectURL(objectUrl);
      resolve(result);
    };
    img.onerror = reject;
    img.src = objectUrl;
  });
